export const TESTS = {
    AA: 'HA_PTA_SLP_AA',
    TRUSTPILOT_REVIEWS: 'HA_PTA_SLP_TrustPilotV2',
    PROPERTY_NAME_IN_LISTING_CARD: 'HA_PTA_LANDING_PropertyTypeNameListingCards',
    SLP_FilterTagRedesign: 'HA_PTA_SLP_FilterTagRedesign',
    DATEPICKER_TOOLTIP: 'HA_PTA_SLP_DatepickersHelpTooltip',
    SLP_PROPERTY_REVIEWS: 'HA_PTA_SLP_PropertyReviewsIteration2',
    QUICK_SERP_FILTERS: 'HA_PTA_SLP_QuickSeRPFilters',
    SLP_PROPERTY_TYPE_PRICES: 'HA_PTA_SLP_FromPricesPropertyTypesCarousel',
    SEO_TEXT_REDESIGN: 'HA_PTA_SLP_SEOTextRedesign',
    OPTIMIZE_PROPERTY_TYPE_SORT: 'HA_PTA_SLP_OptimizePropertyTypeSort',
    WHITE_HEADER: 'HA_PTA_LANDING_WhiteHeader',
    GDPR: 'ha_gdpr_banner'
};

export const EVALUATE = [
    TESTS.AA,
    TESTS.TRUSTPILOT_REVIEWS,
    TESTS.PROPERTY_NAME_IN_LISTING_CARD,
    TESTS.SLP_FilterTagRedesign,
    TESTS.DATEPICKER_TOOLTIP,
    TESTS.SLP_PROPERTY_REVIEWS,
    TESTS.QUICK_SERP_FILTERS,
    TESTS.SLP_PROPERTY_TYPE_PRICES,
    TESTS.SEO_TEXT_REDESIGN,
    TESTS.OPTIMIZE_PROPERTY_TYPE_SORT,
    TESTS.WHITE_HEADER,
    TESTS.GDPR
];

export const EVALUATE_AND_LOG = [];

const hasTest = (abacus, test) => abacus && abacus[test];

export const getValue = (abacus, test) =>
    hasTest(abacus, test) ?
        abacus[test].value :
        null;
